import talent from '../views/talent'

export default {
  path: '/talent',
  component: talent,
  redirect: '/talent/talentWork',
  name: 'Talent',
  meta: {
    title: '人才资源小区'
  },
  children: [
    {
      path: '/talent/talentWork',
      component: () => import('../views/talent/TalentWork'),
      name: 'TalentWork',
      meta: {
        title: '人才工作'
      }
    },
    {
      path: '/talent/talentPool',
      component: () => import('../views/talent/TalentPool'),
      name: 'TalentPool',
      meta: {
        title: '人才资源库'
      }
    },
    {
      path: '/talent/antStar',
      component: () => import('../views/talent/AntStar'),
      name: 'AntStar',
      meta: {
        title: '蚂蚁服务星战'
      }
    },
    {
      path: '/talent/training',
      component: () => import('../views/talent/Training'),
      name: 'Training',
      meta: {
        title: '人才需求'
      }
    },
    {
      path: '/talent/talentCenter',
      component: () => import('../views/talent/TalentCenter'),
      name: 'TalentCenter',
      meta: {
        title: '人才中心审核'
      }
    }
  ]

}
